export default "__VITE_ASSET__C$ZiLvsm__"